/**
 * French candidate dictionary, one file per area so each can be edited on its own.
 * Style: standard international French, formal "vous", gender-neutral wording for the candidate.
 */
import shared from './shared';
import screening from './screening';
import assessment from './assessment';
import interview from './interview';

const fr = { ...shared, ...screening, ...assessment, ...interview };

export default fr;
